const preguntas =[
    {
      titulo: "¿En qué año se estrenó la primera película de Iron Man, que lanzó el Marvel Cinematic Universe?",
      opciones: [
        { textoRespuesta: "2008", isCorrect: true },
        { textoRespuesta: "2005", isCorrect: false },
        { textoRespuesta: "2010", isCorrect: false },
        { textoRespuesta: "2012", isCorrect: false },
      ],
    },
    {
      titulo: "¿Cómo se llama el martillo de Thor?",
      opciones: [
        { textoRespuesta: "Vanir", isCorrect: false },
        { textoRespuesta: "Mjolnir", isCorrect: true },
        { textoRespuesta: "Aesir", isCorrect: false },
        { textoRespuesta: "Norn", isCorrect: false },
      ],
    },
    {
      titulo: "¿De qué está hecho el escudo del Capitán América?",
      opciones: [
        { textoRespuesta: "Adamantium", isCorrect: false },
        { textoRespuesta: "Vibranio", isCorrect: true },
        { textoRespuesta: "Prometeo", isCorrect: false },
        { textoRespuesta: "Carbonadio", isCorrect: false },
      ],
    },
    {
      titulo: "¿Cuál es el nombre del niño que Tony se hace amigo mientras está varado en Iron Man 3?",
      opciones: [
        { textoRespuesta: "Harry", isCorrect: false },
        { textoRespuesta: "Enrique", isCorrect: false },
        { textoRespuesta: "Harley", isCorrect: true },
        { textoRespuesta: "Holden", isCorrect: false },
      ],
    },
    {
      titulo: "¿¿Quién es asesinado por Loki en los Vengadores?",
      opciones: [
        { textoRespuesta: "Maria Hill", isCorrect: false },
        { textoRespuesta: "Nick Fury", isCorrect: false },
        { textoRespuesta: "Agente Coulson", isCorrect: true },
        { textoRespuesta: "Doctor Erik Selvig", isCorrect: false },
      ],
    },
    {
      titulo: "¿Quién mató a los padres de Tony Stark??",
      opciones: [
        { textoRespuesta: "The Winter Soldier", isCorrect: true },
        { textoRespuesta: "Obadiah Stane", isCorrect: false },
        { textoRespuesta: "Loki", isCorrect: false },
        { textoRespuesta: "Thanos", isCorrect: false },
      ],
    },
    {
      titulo: "¿Cuál es la especialidad de Doctor Strange en el campo médico?",
      opciones: [
        { textoRespuesta: "Cirugía Ortopédica", isCorrect: false },
        { textoRespuesta: "Cirugía neurológica", isCorrect: true },
        { textoRespuesta: "Cirugía Cardiovascular", isCorrect: false },
        { textoRespuesta: "Cirugía General", isCorrect: false },
      ],
    },
  ];
  
  export default preguntas;
  